(() => {
  if (window.hsaGuideInstalled) return;
  window.hsaGuideInstalled = true;
  function init(scope) {
    scope.querySelectorAll('[data-hsa-guide]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const body = root.querySelector('[data-guide-body]');
      if (!body) return;
      const time = root.querySelector('[data-reading-time]');
      if (time) {
        const words = (body.textContent || '').trim().split(/\s+/).filter(Boolean).length;
        if (words) { time.textContent = `About ${Math.max(1, Math.ceil(words / 220))} min read`; time.hidden = false; }
      }
      const headings = [...body.querySelectorAll('h2')].filter(h => h.textContent.trim() && !h.closest('.hsa-guide__callout'));
      const toc = root.querySelector('[data-toc]');
      if (toc && headings.length >= 3) {
        const list = toc.querySelector('[data-toc-list]');
        headings.forEach((heading, index) => {
          if (!heading.id) {
            const base = `${root.id}-section-${index + 1}`;
            let id = base, suffix = 1;
            while (document.getElementById(id)) id = `${base}-${suffix++}`;
            heading.id = id;
          }
          const item = document.createElement('li');
          const link = document.createElement('a');
          link.href = `#${encodeURIComponent(heading.id)}`;
          link.textContent = heading.textContent.trim();
          item.append(link); list.append(item);
        });
        toc.querySelector('details').open = window.matchMedia('(min-width: 750px)').matches;
        toc.hidden = false;
      }
      body.querySelectorAll('table').forEach(table => {
        if (table.parentElement.classList.contains('hsa-guide__table-scroll')) return;
        const wrapper = document.createElement('div');
        wrapper.className = 'hsa-guide__table-scroll';
        wrapper.tabIndex = 0;
        wrapper.setAttribute('role', 'region');
        wrapper.setAttribute('aria-label', table.caption?.textContent.trim() || 'Article table; scroll horizontally if needed');
        table.before(wrapper); wrapper.append(table);
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
